


export const tipoUrologica = (dataSemiologia) => {

  const { selected, dolores, hematurias, irritativos, obstructivos, disfuncion } = dataSemiologia;

  let textoSintomasSelect = '';
  let textoDolores      = '';
  let textoHematurias   = '';
  let textoIrritativos  = '';
  let textoObstructivos = '';
  let textoDisfuncion   = '';

  if(selected && selected.length > 0) {
    textoSintomasSelect = ` con sintomas ( ${selected.map( 
      sintoma => {
        if( 
          sintoma.value === 'dolores' 
          || sintoma.value === 'hematurias' 
          || sintoma.value === 'irritativos' 
          || sintoma.value === 'obstructivos' 
          || sintoma.value === 'disfuncion' 
        ) return '';
        return sintoma.text;
      }
    ).join(', ')} )`;
  }

  if( dolores && dolores.length > 0 ) {
    textoDolores = ` con dolores ( ${dolores.map( dolor => dolor.text ).join(', ')} )`;
  }

  if( hematurias && hematurias.length > 0 ) {
    textoHematurias = ` con hematurias ( ${hematurias.map( hematuria => hematuria.text ).join(', ')} )`;
  }

  if( irritativos && irritativos.length > 0 ) {
    textoIrritativos = ` con Irritativos ( ${irritativos.map( item => item.text ).join(', ')} )`;
  }

  if( obstructivos && obstructivos.length > 0 ) {
    textoObstructivos = ` con Obstructivos ( ${obstructivos.map( item => item.text ).join(', ')} )`;
  }

  if( disfuncion && disfuncion.length > 0 ) {
    textoDisfuncion = ` con Disfuncion ( ${disfuncion.map( item => item.text ).join(', ')} )`;
  }

  return `${textoSintomasSelect}${textoDolores}${textoHematurias}${textoIrritativos}${textoObstructivos}${textoDisfuncion}`;
  
}